var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data && _vm.data.total)?_c('v-chart',{staticClass:"offline-chart",attrs:{"option":_vm.option,"autoresize":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }